module.exports = __webpack_public_path__ + "static/media/PDF_original.d179747e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Content/Assets/images/PDF_original.png
// module id = 416
// module chunks = 0